module.exports = __webpack_public_path__ + "media/images/new_landing/people/ludek-motycka-4eae9dff1c11995c1a5a6139697c1467.jpg";